import { useState } from "react";

const QUESTIONS = [
  { key: "feeling", q: "How the hell are you, really?", hint: "Physically, mentally, emotionally." },
  { key: "movement", q: "Did you move your body or make excuses louder than your goals?" },
  { key: "strong_vs_cement", q: "What felt strong? What felt like dragging yourself through wet cement?" },
  { key: "eating", q: "How did you eat this week?", hint: "Fueled? Restrictive? Snacky as hell? Balanced? Be honest." },
  { key: "drained", q: "What drained the life out of you this week?" },
  { key: "proud", q: "What did you do that made you think, \u201cDamn. I\u2019m actually doing this\u201d?" },
  { key: "fell_apart", q: "Where did things fall apart a little?" },
  { key: "make_easier", q: "And what can you make easier instead of beating yourself up?" },
];

const EMPTY = Object.fromEntries(QUESTIONS.map((x) => [x.key, ""]));

export const CheckinForm = ({ options, onSubmit, submitting }) => {
  const [answers, setAnswers] = useState(EMPTY);
  const [needMore, setNeedMore] = useState([]);
  const [proved, setProved] = useState("");
  const [promise, setPromise] = useState("");

  const toggleNeed = (o) => setNeedMore((n) => (n.includes(o) ? n.filter((x) => x !== o) : [...n, o]));
  const canSubmit = proved.trim() && promise.trim() && !submitting;

  return (
    <form
      className="space-y-8"
      data-testid="checkin-form"
      onSubmit={(e) => { e.preventDefault(); if (canSubmit) onSubmit({ ...answers, need_more: needMore, proved, promise }); }}
    >
      {QUESTIONS.map((item, i) => (
        <div key={item.key} className="card">
          <p className="eyebrow" style={{ color: "#FF0055" }}>{String(i + 1).padStart(2, "0")}</p>
          <p className="font-display font-black text-lg md:text-xl mt-2 uppercase leading-tight">{item.q}</p>
          {item.hint && <p className="text-sm text-zinc-400 mt-1">{item.hint}</p>}
          <textarea
            className="input mt-4"
            rows={2}
            value={answers[item.key]}
            onChange={(e) => setAnswers({ ...answers, [item.key]: e.target.value })}
            placeholder="Tell the truth…"
            data-testid={`checkin-${item.key}`}
          />
        </div>
      ))}

      <div className="card">
        <p className="eyebrow" style={{ color: "#FF0055" }}>09</p>
        <p className="font-display font-black text-lg md:text-xl mt-2 uppercase leading-tight">What do you need more of next week?</p>
        <div className="flex flex-wrap gap-2 mt-4" data-testid="need-more-options">
          {options.map((o) => {
            const on = needMore.includes(o);
            return (
              <button
                type="button"
                key={o}
                onClick={() => toggleNeed(o)}
                data-testid={`need-${o.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-4 py-2 text-xs font-bold uppercase tracking-widest transition-colors"
                style={{
                  border: `1px solid ${on ? "#FF0055" : "#3f3f46"}`,
                  background: on ? "#FF0055" : "transparent",
                  color: on ? "white" : "#a1a1aa",
                }}
              >
                {o}
              </button>
            );
          })}
        </div>
      </div>

      <div className="card" style={{ borderColor: "#FF0055" }}>
        <p className="eyebrow" style={{ color: "#FF0055" }}>Finish this</p>
        <p className="font-display font-black text-xl md:text-2xl mt-2 uppercase leading-tight">
          This week, I proved to myself that I can <span style={{ color: "#FF0055" }}>__________.</span>
        </p>
        <input
          className="input mt-4"
          value={proved}
          onChange={(e) => setProved(e.target.value)}
          placeholder="…"
          data-testid="checkin-proved"
        />
      </div>

      <div className="card" style={{ borderColor: "#FF0055" }}>
        <p className="eyebrow" style={{ color: "#FF0055" }}>Next week</p>
        <p className="font-display font-black text-xl md:text-2xl mt-2 uppercase leading-tight">
          What ONE promise will you keep next week?
        </p>
        <input
          className="input mt-4"
          value={promise}
          onChange={(e) => setPromise(e.target.value)}
          placeholder="One promise. Small enough to keep."
          data-testid="checkin-promise"
        />
      </div>

      <button type="submit" className="btn-primary w-full md:w-auto" disabled={!canSubmit} data-testid="checkin-submit">
        {submitting ? "Coach is reading…" : "Lock in the check-in"}
      </button>
    </form>
  );
};
